// extracted by mini-css-extract-plugin
export default {"swipe":"styles_swipe__1Hlp7","slide-left":"styles_slide-left__z0kNf"};